import { render, staticRenderFns } from "./BoothAdvertising.vue?vue&type=template&id=bb461b36&scoped=true"
import script from "./BoothAdvertising.vue?vue&type=script&lang=js"
export * from "./BoothAdvertising.vue?vue&type=script&lang=js"
import style0 from "./BoothAdvertising.vue?vue&type=style&index=0&id=bb461b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb461b36",
  null
  
)

export default component.exports